/**
 * LogoPulse Brand Colors
 * Central color palette for the entire application
 */

export const colors = {
  // Primary Brand Colors
  primary: {
    main: '#DCF995',      // Neon yellow (brand color)
    light: '#E8FBB3',     // Light yellow (hover states)
    dark: '#C4E673',      // Medium yellow (active states)
    darker: '#A8D142',    // Darker yellow (pressed states)
  },

  // Secondary/Text Colors
  secondary: {
    main: '#1B0826',      // Dark purple (logo/text color)
    light: '#3D1A4F',     // Light purple
    dark: '#0D0413',      // Darker purple
    muted: '#6B5B7B',     // Muted purple (secondary text)
  },

  // Background Colors
  background: {
    default: '#fafafa',   // Light gray (page background)
    paper: '#ffffff',     // White (card backgrounds)
  },

  // Feedback Colors
  error: {
    main: '#dc2626',
    light: '#ef4444',
    dark: '#b91c1c',
  },

  warning: {
    main: '#f59e0b',
    light: '#fbbf24',
    dark: '#d97706',
  },

  info: {
    main: '#3b82f6',
    light: '#60a5fa',
    dark: '#2563eb',
  },

  success: {
    main: '#10b981',
    light: '#34d399',
    dark: '#059669',
  },

  // Utility Colors
  border: '#e0e0e0',
  divider: 'rgba(0, 0, 0, 0.12)',
} as const;

export type Colors = typeof colors;
